import SignIn from '@/components/auth/SignIn'
import SignUp from '@/components/auth/SignUp'
import SignOut from '@/components/auth/SignOut'
import PasswordReset from '@/components/auth/PasswordReset'

export default [
  {path: '/sign-in', component: SignIn},
  {path: '/sign-up', component: SignUp},
  {path: '/sign-out', component: SignOut},
  {path: '/reset', component: PasswordReset}
]



// WEBPACK FOOTER //
// ./src/router/auth/routes.js